'use strict';

/**
 * DO NOT MODIFY
 * Generated from yarn nx run illustrations:sync
 */

/**
 * Currently used on web for interpolating the URL to CDN hosted asset using the name and version number.
 *
 * For example, given the following HeroSquare versionMap, '{ someIllustration: 2 }', and
 * JSX such as '<HeroSquare name="someIllustration />' will result in an image with the following URL:
 *
 * 'https://static-assets.coinbase.com/design-system/illustrations/heroSquare/light/someIllustration-2.svg
 *
 * In addition, this file is used to populate HeroSquare stories in percy, so the sort order based on createdAt is important.
 */
const versionMap = {
  startToday: 2,
  selfCustody: 3,
  quickBuy: 2,
  idIssue: 2,
  phoneNumber: 2,
  defiEnrollBoost: 2,
  idCard: 2,
  invest: 2,
  payUpFront: 3,
  directDepositPhone: 3,
  selectReward: 2,
  paperHands: 2,
  advancedTradingUi: 1,
  powerOfCrypto: 4,
  cardReloadFunds: 2,
  desktopUnknown: 2,
  crossBorderPayments: 3,
  receivedCard: 2,
  leverage: 2,
  automaticPayments: 2,
  borrowWallet: 3,
  walletSecurity: 3,
  videoRequest: 2,
  downloadCoinbaseWallet: 2,
  accessToAdvancedCharts: 3,
  errorRefresh: 2,
  tradeImmediately: 3,
  coinbaseOneProtectedCrypto: 2,
  coinbaseOneDocWarning: 2,
  errorWeb400: 2,
  earnGrowth: 2,
  secureStorage: 3,
  notificationsAndUpdates: 2,
  camera: 3,
  cardBoosted: 2,
  linkingYourWalletToYourCoinbaseAccount: 3,
  sidechain: 2,
  discardAssets: 3,
  cryptoWallet: 3,
  docError: 2,
  taxesDetails: 2,
  coinbaseCardPocket: 2,
  referralsAvatars: 4,
  walletNotifications: 2,
  errorApp500: 3,
  insufficientBalance: 3,
  commerceAccounting: 2,
  myNameIsSatoshi: 2,
  estimatedAmount: 2,
  idFront: 2,
  errorWeb404: 2,
  earnInterest: 2,
  idBack: 1,
  restrictedCountry: 4,
  coinCheckmark: 2,
  walletLoading: 2,
  defiDecentralizedTradingExchange: 3,
  ratingsAndReviews: 4,
  advancedTrading: 3,
  rotatingRewards: 5,
  getStartedInMinutes: 3,
  cryptoPortfolio: 3,
  poweredByEthereum: 3,
  p2pPayments: 3,
  receiveGift: 2,
  blockchain: 2,
  reviewInfo: 3,
  feeScale: 3,
  emptyStateNft404Page: 3,
  trendingHotAssets: 2,
  coinbaseIsDown: 3,
  webRAT: 2,
  coinbaseOneInsufficientWallet: 3,
  insuranceProtection: 3,
  stopLimitOrder: 3,
  slippageTolerance: 2,
  multicoinSupport: 3,
  verifyBankTransactions: 3,
  idAngles: 3,
  bigBtc: 4,
  verifyInfo: 3,
  secureAndTrusted: 3,
  cryptoAssets: 4,
  recurringReward: 3,
  backedByUsDollar: 3,
  fileYourCryptoTaxesCheck: 4,
  openEmail: 2,
  holdCrypto: 3,
  selfCustodyCrypto: 3,
  cryptoEconomy: 3,
  invite: 3,
  addBankAccount: 3,
  stopLimitOrderDown: 3,
  encryptedEverything: 3,
  earnIdVerification: 2,
  coinsInWallet: 2,
  coinbaseCardIssue: 2,
  coinbaseIsDownMobile: 2,
  verifyIdDetails: 2,
  borrow: 3,
  focusLimitOrders: 2,
  cryptoAppsWallet: 3,
  sendToUsername: 2,
  error400: 2,
  coinbaseOneCardWarning: 2,
  sendCryptoFaster: 2,
  selectCorrectCrypto: 3,
  desktopAuthorized: 2,
  brdGift: 3,
  bitcoinAndOtherCrypto: 2,
  remittances: 3,
  securityShield: 2,
  verifyCardTransactions: 3,
  coinbaseOneWaitlist: 3,
  coinbaseWalletToTrade: 2,
  referralsBitcoin: 4,
  phoneUnknown: 2,
  governance: 3,
  rocket: 2,
  cardAndPhone: 1,
  noFees: 3,
  coinbaseOneDiscountedAmount: 3,
  portfolioPerformance: 3,
  moneyDecentralized: 3,
  idVerificationSecure: 3,
  contactsListWarning: 2,
  marginWarning: 2,
  futures: 4,
  emptyStateNftSoldOut: 3,
  emptyStateCheckBackLater: 3,
  emptyCollection: 3,
  walletAsset: 2,
  primeEarn: 3,
  primeStaking: 3,
  advancedTradingChartsIndicatorsCandles: 1,
  congratulationsOnEarningCrypto: 2,
  cryptoForBeginners: 3,
  didDecentralizedIdentity: 3,
  dappsArts: 3,
  dappsFinance: 4,
  dappsMusic: 3,
  earnToLearn: 3,
  gainsAndLosses: 2,
  layeredNetworks: 3,
  optInPushNotificationsEmail: 2,
  quickAndSimple: 3,
  semiCustodial: 4,
  shareOnSocialMedia: 3,
  coinbaseCardSpend: 2,
  completeAQuiz: 3,
  multiPlatformMobileAppBrowserExtension: 3,
  buyFirstCrypto: 2,
  stayInControlSelfHostedWalletsStorage: 3,
  stressTestedColdStorage: 3,
  referralsWalletPhones: 2,
  whyNotBoth: 3,
  documentCertified: 2,
  digitalCollectibles: 3,
  ethStakingUpsell: 3,
  videoReview: 3,
  mic: 3,
  pending: 3,
  coinbaseCardLock: 2,
  coinbaseOneLogo: 3,
  earnMore: 2,
  switchAdvancedToSimpleTrading: 2,
  decentralization: 3,
  decentralizedWebWeb3: 3,
  multipleAccountsWalletsForOneUser: 3,
  add2Fa: 3,
  coinbaseOneSavingFunds: 3,
  cashExcitement: 2,
  verifyEmail: 3,
  defiEarn: 2,
  coinbaseRedesigned: 2,
  documentSuccess: 2,
  addCreditCard: 3,
  onTheList: 3,
  collectingNfts: 3,
  supportAndMore: 3,
  japanVerifyId: 2,
  addPhoneNumber: 2,
  routingAccount: 3,
  fileYourCryptoTaxes: 4,
  watchVideos: 2,
  holdingCrypto: 2,
  hardwareWallets: 3,
  limitOrders: 3,
  emailNotification: 2,
  transactionLimit: 3,
  diamondHands: 4,
  freeBtc: 2,
  accountUnderReview: 2,
  twoIdVerify: 2,
  earn: 2,
  yourContacts: 2,
  exploreDecentralizedApps: 2,
  networkWarning: 3,
  ledgerPlugin: 3,
  walletUi: 2,
  browserExtension: 3,
  margin: 2,
  secureGlobalTransactions: 4,
  stableValue: 3,
  coinbaseCardSpendCrypto: 3,
  orderBooks: 1,
  dappsGaming: 3,
  videoUpload: 3,
  coinbaseCard: 2,
  readyToTrade: 2,
  defiRisk: 2,
  staking: 2,
  errorWeb500: 2,
  cryptoApps: 3,
  gasFeesNetworkFees: 3,
  addMoreCrypto: 2,
  cryptoAndMore: 3,
  notificationsAlt: 3,
  appTrackingTransparency: 3,
  coinbaseFees: 2,
  basedInUsa: 3,
  earnCryptoCard: 3,
  ledgerAccess: 3,
  p2pGifting: 2,
  performance: 2,
  defiDecentralizedBorrowingLending: 2,
  currencyPairs: 3,
  commerceInvoices: 2,
  coinbaseOnePhoneLightning: 3,
  tradeHistory: 3,
  collectableNfts: 4,
  earnCryptoInterest: 3,
  earnNuxHome: 3,
  dappsL2Support: 3,
  coinbaseOneUSDCIncentives: 2,
  coinbaseOnePercentOff: 2,
  coinbaseOneRewards: 2,
  iceCreamMeltingSystemError: 4,
  faceMatchReal: 3,
  walletFlyEmptyState: 2,
  catLostSystemError: 2,
  coinbaseOneWalletWarning: 3,
  chickenFishSystemError: 2,
  artFrameEmptyState: 3,
  cardError: 2,
  squidEmptyState: 3,
  spacedOutSystemError: 3,
  serverCatSystemError: 2,
  alienDonutSystemError: 2,
  coinbaseOneWelcome: 2,
  catHoldingWalletEmptyState: 3,
  browseDecentralizedApps: 4,
  exchangeEmptyState: 3,
  retailUSDCRewards: 3,
  coinbaseOneTokenRewards: 2,
  bitcoinGlobe: 3,
  ethStakingRewards: 2,
  ethereumToWallet: 4,
  globalTransactions: 3,
  polling: 2,
  hiddenCollection: 2,
  earnSuccess: 4,
  bigWarning: 4,
  bigError: 3,
  success: 3,
  processing: 2,
  recommendInvest: 4,
  mining: 3,
  defiHow: 3,
  primeDeFi: 3,
  enableBiometrics: 2,
  keyGeneration: 3,
  web3ActivityError: 2,
  web3ActivitySigned: 3,
  web3MobileSetupSuccess: 3,
  requestSent: 2,
  web3MobileSetupStart: 2,
  cloudBacking: 2,
  stakingMissedReturns: 1,
  claimCryptoUsername: 0,
  ensProfilePic: 0,
  noLongAddresses: 0,
  referralsCoinbaseOne: 0,
  namePortfolio: 0,
  multiplePortfolios: 0,
  coinbaseOneUSDCBig: 0,
  usdtToUSDC: 0,
  dappsGeneral: 0,
  noFeesMotion: 0,
  stablecoin: 0,
  connectPeople: 0,
  engagement: 0,
  unlockKey: 1,
  developer: 0,
  bridge: 0,
  vote: 0,
  storage: 1,
  layerOne: 1,
  privateKey: 0,
  indexer: 0,
  layerTwo: 0,
  innovation: 0,
  scalable: 0,
  minting: 0,
  protocol: 0,
  tradeGeneral: 1,
  smartContract: 0,
  airdrop: 0,
  quest: 0,
  lend: 0,
  digitalGold: 0,
  borrowCoins: 0,
  earnGlobe: 0,
  generative: 0,
  oracle: 0,
  exchange: 0,
  public: 0,
  onChain: 0,
  buy: 0,
  settlement: 0,
  offChain: 0,
  governanceMallet: 0,
  platform: 0,
  fiat: 0,
  lowCost: 0,
  tools: 0,
  cloud: 0,
  communication: 0,
  anonymous: 0,
  sustainable: 0,
  gamer: 0,
  private: 0
};
module.exports = versionMap;
//# sourceMappingURL=versionMap.js.map
